import { toast } from 'react-toastify';
import i18n from 'src/localization/i18n';
import { Invoice, downloadInvoicePdf } from 'src/services/invoices';
import { hideSpinnerToast, showSpinnerToast } from 'src/utils/spinnerToaster';

export const downloadWithFeedback = async (
  invoice: Pick<Invoice, 'id' | 'name'>,
  t: (key: string) => string,
): Promise<void> => {
  showSpinnerToast(i18n.t('invoices.actions.downloading'));
  try {
    await downloadInvoicePdf(invoice.id, invoice.name);
  } catch {
    toast.error(t('invoices.errors.pdf_unavailable'));
  } finally {
    hideSpinnerToast();
  }
};
